(function (root) {
  'use strict';
  function mount(element, options) {
    var api = options.api, token = options.token, generation = 0, member = null, inviter = 'your friend', busy = false;
    var nodes = {};
    ['heading', 'form', 'firstName', 'name-field', 'month', 'day', 'identity', 'explanation', 'success-copy', 'error', 'start', 'sign-in', 'switch', 'save', 'retry', 'unavailable-copy'].forEach(function (key) { nodes[key] = element.querySelector('[data-join-' + key + ']'); });
    var controller = { state: 'loading' };
    function show(state) {
      controller.state = state;
      element.querySelectorAll('[data-join-state]').forEach(function (node) { node.hidden = node.dataset.joinState !== state; });
      var heading = element.querySelector('[data-join-state="' + state + '"] h1');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus(); }
    }
    function clearProfile() {
      member = null;
      nodes.firstName.value = ''; nodes.month.value = ''; nodes.day.value = ''; nodes.identity.textContent = ''; nodes.error.textContent = '';
    }
    function paint(data) {
      clearProfile(); member = data.member;
      inviter = data.invitation.inviterFirstName || 'your friend';
      nodes.heading.textContent = data.invitation.inviterFirstName ? inviter + ' invited you to join Reminders.' : 'A friend invited you to join Reminders.';
      nodes.explanation.textContent = "We'll save this to your account and share the day and month with " + inviter + ' so they can remember you too.';
      if (!member) { show('landing'); return; }
      if (member.acceptedInvitation === true) { nodes['success-copy'].textContent = "You're ready. Your birthday has been shared with " + inviter + '.'; show('success'); return; }
      nodes.identity.textContent = member.firstName ? 'Joining as ' + member.firstName : 'You’re signed in. Confirm your birthday to finish joining.';
      nodes['name-field'].hidden = !!(member.firstName && member.firstName.trim());
      if (member.birthday) { nodes.month.value = String(member.birthday.month); nodes.day.value = String(member.birthday.day); }
      show('birthday');
    }
    async function refresh() {
      var request = ++generation; clearProfile(); show('loading');
      if (!/^[a-f0-9]{32}$/.test(token || '')) { nodes['unavailable-copy'].textContent = 'This invitation is no longer available. Ask your friend for a fresh invitation.'; show('unavailable'); return; }
      try { var data = await api.getBirthdayInvitation(token); if (request === generation) paint(data); }
      catch (error) {
        if (request !== generation) return;
        nodes['unavailable-copy'].textContent = error.code === 'LINK_INVALID' ? 'This invitation is no longer available. Ask your friend for a fresh invitation.' : 'We couldn’t load your invitation. Check your connection and try again.';
        show('unavailable');
      }
    }
    async function authenticate() {
      if (busy) return;
      await options.authenticate({ source: 'birthday_invitation', birthdayInvitationToken: token, onVerified: refresh });
    }
    async function switchAccount() {
      if (busy) return;
      ++generation; clearProfile(); show('loading'); busy = true;
      try { await api.logout(); api.clearMe(); show('landing'); }
      catch (_) { nodes['unavailable-copy'].textContent = 'We couldn’t switch accounts. Try again.'; show('unavailable'); return; }
      finally { busy = false; }
      await authenticate();
    }
    async function submit(event) {
      event.preventDefault(); if (busy || !member) return;
      var month = Number(nodes.month.value), day = Number(nodes.day.value), firstName = nodes.firstName.value.trim();
      nodes.error.textContent = '';
      if (!Number.isInteger(month) || month < 1 || month > 12 || !Number.isInteger(day) || day < 1 || day > new Date(2000, month, 0).getDate()) { nodes.error.textContent = 'Add a valid day and month.'; nodes.day.focus(); return; }
      if (!member.firstName?.trim() && (!firstName || firstName.length > 60)) { nodes.error.textContent = 'Add your first name.'; nodes.firstName.focus(); return; }
      var body = { month: month, day: day, expectedMemberId: member.id }; if (!member.firstName?.trim()) body.firstName = firstName;
      var request = generation; busy = true; nodes.save.disabled = true; nodes.switch.disabled = true;
      try {
        await api.acceptBirthdayInvitation(token, body);
        if (request !== generation) return;
        api.clearMe(); nodes['success-copy'].textContent = "You're ready. Your birthday has been shared with " + inviter + '.'; show('success');
      } catch (error) {
        if (request !== generation) return;
        if (error.code === 'EDIT_CONFLICT' && error.field === 'member') { await refresh(); nodes.error.textContent = 'Your signed-in account changed. Check this account before confirming.'; }
        else if (error.code === 'UNAUTHENTICATED') { clearProfile(); show('landing'); }
        else if (error.code === 'LINK_INVALID') { nodes.error.textContent = 'This invitation is no longer available. Your account is still ready to use. Ask your friend for a fresh invitation.'; }
        else if (['EDIT_CONFLICT', 'CHECKOUT_PENDING', 'BOOKED_CYCLE'].indexOf(error.code) >= 0) nodes.error.textContent = error.message || 'This reminder has changed. Ask your friend to check it.';
        else nodes.error.textContent = 'Your account is ready. We couldn’t save your birthday. Check your connection and try again.';
      } finally { busy = false; nodes.save.disabled = false; nodes.switch.disabled = false; }
    }
    function identityChanged(event) {
      var me = event.detail && event.detail.me;
      if (member && me && (!me.signedIn || !me.member || me.member.id !== member.id)) refresh();
    }
    async function checkIdentity() {
      if (!member || busy || !root.document || root.document.visibilityState === 'hidden') return;
      var displayedId = member.id, request = generation;
      try { var me = await api.me({ force: true }); if (request === generation && (!me.signedIn || !me.member || me.member.id !== displayedId)) await refresh(); }
      catch (_) { /* The server precondition still guards confirmation offline. */ }
    }
    if (root.document && root.document.addEventListener) {
      root.document.addEventListener('fb-reminders:me', identityChanged);
      root.document.addEventListener('visibilitychange', checkIdentity);
    }
    var listeners = [[nodes.start, 'click', authenticate], [nodes['sign-in'], 'click', authenticate], [nodes.switch, 'click', switchAccount], [nodes.retry, 'click', refresh], [nodes.form, 'submit', submit]];
    listeners.forEach(function (entry) { entry[0].addEventListener(entry[1], entry[2]); });
    controller.refresh = refresh;
    controller.destroy = function () { if (root.document && root.document.removeEventListener) { root.document.removeEventListener('fb-reminders:me', identityChanged); root.document.removeEventListener('visibilitychange', checkIdentity); } ++generation; clearProfile(); listeners.forEach(function (entry) { entry[0].removeEventListener(entry[1], entry[2]); }); };
    controller.ready = refresh(); return controller;
  }
  root.FBRemindersJoin = { mount: mount };
})(typeof window !== 'undefined' ? window : globalThis);
